import { ErrorBoundary } from '@sentry/react';
import React, { Suspense } from 'react';

import {
  Content,
  Header,
  PageTitle,
  SidebarTrigger,
  TableSkeleton,
  VStack,
} from '@eluve/components';
import { FilterableAppointmentsTable } from '@eluve/frontend-feature-appointment';
import { useCaptureEventOnMount } from '@eluve/posthog-react';
import { useIsFeatureFlagEnabled } from '@eluve/smart-blocks';

export const AppointmentsListPage: React.FC = () => {
  useCaptureEventOnMount('page_view_appointments_list');

  const showSuperbills = useIsFeatureFlagEnabled('BILLING_CODE_PRICES');
  const isBulkChartExportEnabled = useIsFeatureFlagEnabled('BULK_CHART_EXPORT');

  return (
    <>
      <Header>
        <SidebarTrigger />
        <PageTitle>Appointments</PageTitle>
      </Header>
      <Content padded>
        <Suspense fallback={<TableSkeleton numRows={20} />}>
          <ErrorBoundary
            fallback={
              <VStack>
                <p>Failed to load appointment data.</p>
                <TableSkeleton numRows={5} />
              </VStack>
            }
          >
            <FilterableAppointmentsTable
              includeSuperbillFiles={showSuperbills}
              enableRowSelection={isBulkChartExportEnabled}
            />
          </ErrorBoundary>
        </Suspense>
      </Content>
    </>
  );
};
